import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=06aafbb7&scoped=true&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"
import style0 from "./Page.vue?vue&type=style&index=0&id=06aafbb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aafbb7",
  null
  
)

export default component.exports